import React, { forwardRef } from 'react';
import { FormattedMessage } from 'react-intl';

import { TextField } from '../../../../../../common/form/text-field';
import { IPhoneStepFormProps } from './phone-step-form.models';
import { Button } from '../../../../../../common/button-new';
import { SmartCaptcha, Form, IFormImperativeHandleProps } from '../../../../../../common';
import { CaptchaType } from '../../../../../../../graphql/configuration';

export const PhoneStepForm = forwardRef<IFormImperativeHandleProps, IPhoneStepFormProps>(({
  onSubmit,
  validationSchema,
  defaultValues,
  isTimerRunning,
  time,
  onPhoneChange,
  isVisible,
  onSuccess,
  captcha,
  isResetCaptcha,
  onNoSubmit,
  isNewNumber,
  isSubmitDisabled,
  onChallengeHidden,
}, ref): JSX.Element => {
  const buttonLabel = (!!time && isTimerRunning)
    ? <FormattedMessage id="common.nextButton.label" />
    : <FormattedMessage id="resetPassword.phoneStep.nextButton.label" />;

  const handleFormChange = React.useCallback((values: any) => {
    if (onPhoneChange && values.username) {
      onPhoneChange(values.username);
    }
  }, [onPhoneChange]);

  return (
    <Form
      ref={ref}
      onSubmit={isTimerRunning && !isNewNumber ? onNoSubmit : onSubmit}
      defaultValues={defaultValues}
      validationSchema={validationSchema}
      onChangeValuesDependencies={handleFormChange}
    >
      <TextField
        autoFocus
        name="username"
        type="tel"
        fullWidth
        label={(
          <FormattedMessage
            id="common.phone.label"
          />
        )}
      />
      {captcha?.type === CaptchaType.smartCaptcha && !(isTimerRunning && !isNewNumber) && (
        <SmartCaptcha
          onSuccess={onSuccess}
          isVisible={isVisible}
          isVisibleCaptcha={!!captcha?.isVisibleCaptcha}
          isReset={isResetCaptcha}
          onChallengeHidden={onChallengeHidden}
        />
      )}
      <Button
        type="submit"
        style="dark"
        testId="request-code-timer-button"
        ariaLabel="resetPassword.phoneStep.nextButton.ariaLabel"
        disabled={isSubmitDisabled}
      >
        {buttonLabel}
      </Button>
    </Form>
  );
});

